var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnexpectedError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "132px",
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7225CC11-65BE-4340-9EB6-B07C94162D55@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Replacements",
    transform: "translate(-88.000000, -411.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unexpected-Error",
    transform: "translate(88.000000, 411.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 132,
    height: 132
  }), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-web-error@140x140",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.392,56 C1.392,86.927946 26.464054,112 57.392,112 C88.319946,112 113.392,86.927946 113.392,56 C113.392,25.072054 88.319946,0 57.392,0 C26.464054,0 1.392,25.072054 1.392,56 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7164,43.68 L10.0496,43.68 C8.5032027,43.68 7.2496,44.9336027 7.2496,46.48 L7.2496,91.4634 L82.5164,91.4634 L82.5164,46.48 C82.5164,44.9336027 81.2627973,43.68 79.7164,43.68 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6E2FF",
    fillRule: "nonzero",
    points: "77.2034 48.993 12.6368 48.993 12.5626 91.4634 77.2034 91.4634"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "77.2034 48.993 12.6368 48.993 12.5626 91.4634 77.2034 91.4634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.463,101.7044 C9.463,102.980178 25.3210742,104.0144 44.883,104.0144 C64.4449258,104.0144 80.303,102.980178 80.303,101.7044 C80.303,100.428622 64.4449258,99.3944 44.883,99.3944 C25.3210742,99.3944 9.463,100.428622 9.463,101.7044 Z",
    id: "Path",
    fill: "#D6E2FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.158,96.7764 L0.608,96.7764 L0.608,92.8564 C0.608,92.0832014 1.23480135,91.4564 2.008,91.4564 L87.758,91.4564 C88.5311986,91.4564 89.158,92.0832014 89.158,92.8564 L89.158,96.7764 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.158,96.7764 C80.9337062,99.1266188 72.4219102,100.31876 63.8684,100.3184 L25.8976,100.3184 C17.3440974,100.318651 8.83231657,99.1265115 0.608,96.7764 L89.158,96.7764 L89.158,96.7764 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.603,80.2382052 C50.7298136,80.239753 49.8921712,79.8924993 49.2762,79.2736 L44.883,74.8804 L40.4898,79.2736 C39.6585144,80.1046356 38.4470227,80.4290585 37.311682,80.1246618 C36.1763414,79.8202651 35.289637,78.933294 34.985582,77.7978617 C34.6815269,76.6624295 35.0063144,75.4510355 35.8376,74.62 L40.2308,70.2254 L35.8376,65.8308 C34.603865,64.5378092 34.6279526,62.4963892 35.891853,61.2328692 C37.1557535,59.9693491 39.1971806,59.9458759 40.4898,61.18 L44.883,65.5746 L49.2762,61.18 C50.5608696,59.8949439 52.6440438,59.8946306 53.9290999,61.1793001 C55.214156,62.4639696 55.2144695,64.5471438 53.9298,65.8322 L49.5352,70.2268 L53.9298,74.62 C54.8700857,75.5610791 55.1510914,76.9758127 54.6418436,78.2048098 C54.1325957,79.4338068 52.9333259,80.2351727 51.603,80.2354 L51.603,80.2382052 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6E2FF",
    fillRule: "nonzero",
    points: "49.888 7.9128 110.2434 7.9128 110.2434 55.9986 49.888 55.9986"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    strokeLinejoin: "round",
    points: "49.888 7.9128 110.2434 7.9128 110.2434 55.9986 49.888 55.9986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.566,7.9128 L54.5654,7.9128 C53.3246338,7.9128 52.1347066,8.4057882 51.2574837,9.28327368 C50.3802608,10.1607592 49.8879998,11.3508338 49.8879998,12.5916 L49.8879998,19.04 L110.2434,19.04 L110.2434,12.5916 C110.2434,11.3508338 109.751139,10.1607592 108.873916,9.28327368 C107.996693,8.4057882 106.806766,7.9128 105.566,7.9128 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.566,7.9128 L54.5654,7.9128 C51.9821433,7.9128 49.888,10.0069433 49.888,12.5902 L49.888,19.04 L110.2434,19.04 L110.2434,12.5902 C110.2434,11.3496764 109.750604,10.1599614 108.873421,9.28277874 C107.996239,8.40559609 106.806524,7.9128 105.566,7.9128 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5654,13.447 C54.5654,14.2827872 55.0112871,15.0550864 55.7351,15.4729799 C56.4589129,15.8908735 57.3506871,15.8908735 58.0745,15.4729799 C58.7983129,15.0550864 59.2442,14.2827872 59.2442,13.447 C59.2442,12.6112128 58.7983129,11.8389136 58.0745,11.4210201 C57.3506871,11.0031265 56.4589129,11.0031265 55.7351,11.4210201 C55.0112871,11.8389136 54.5654,12.6112128 54.5654,13.447 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#D6E2FF",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9202,13.447 C63.9202,14.7390149 64.9675851,15.7864 66.2596,15.7864 C67.5516149,15.7864 68.599,14.7390149 68.599,13.447 C68.599,12.1549851 67.5516149,11.1076 66.2596,11.1076 C64.9675851,11.1076 63.9202,12.1549851 63.9202,13.447 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#D6E2FF",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.275,13.447 C73.275,14.7390149 74.3223851,15.7864 75.6144,15.7864 C76.9064149,15.7864 77.9538,14.7390149 77.9538,13.447 C77.9538,12.1549851 76.9064149,11.1076 75.6144,11.1076 C74.3223851,11.1076 73.275,12.1549851 73.275,13.447 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#D6E2FF",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0886,31.36 C63.0886,32.6357778 64.1228222,33.67 65.3986,33.67 C66.6743778,33.67 67.7086,32.6357778 67.7086,31.36 C67.7086,30.0842222 66.6743778,29.05 65.3986,29.05 C64.1228222,29.05 63.0886,30.0842222 63.0886,31.36 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3486,31.36 C92.3486,32.6357778 93.3828222,33.67 94.6586,33.67 C95.9343778,33.67 96.9686,32.6357778 96.9686,31.36 C96.9686,30.0842222 95.9343778,29.05 94.6586,29.05 C93.3828222,29.05 92.3486,30.0842222 92.3486,31.36 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.168,41.4792 C99.1881633,42.2784518 98.7732924,43.0257732 98.0842851,43.4313333 C97.3952778,43.8368935 96.5405222,43.8368935 95.8515149,43.4313333 C95.1625076,43.0257732 94.7476367,42.2784518 94.7678,41.4792 C94.7678,40.264 96.9686,35.98 96.9686,35.98 C96.9686,35.98 99.168,40.264 99.168,41.4792 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4178,47.9514002 C72.8882055,47.9516264 72.3881622,47.7073642 72.0627954,47.2895045 C71.7374285,46.8716448 71.6231772,46.3269852 71.7532,45.8136 C72.7184893,42.0318175 76.1248675,39.3856937 80.0279,39.3856937 C83.9309325,39.3856937 87.3373107,42.0318175 88.3026,45.8136 C88.4326228,46.3269852 88.3183715,46.8716448 87.9930046,47.2895045 C87.6676378,47.7073642 87.1675945,47.9516264 86.638,47.9514002 C84.4619019,47.4866189 82.2513669,47.2009959 80.0286,47.0974 C77.8053639,47.2009196 75.5943576,47.4865431 73.4178,47.9514002 L73.4178,47.9514002 Z",
    id: "Path",
    stroke: "#4C76E0",
    strokeWidth: 1.4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnexpectedError);
export default __webpack_public_path__ + "static/media/unexpected-error.d9abc474f3082a86f9f36829ce921d7c.svg";
export { ForwardRef as ReactComponent };